import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { SplitText } from "gsap/SplitText";
import Lenis from "lenis";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(SplitText);

export default class ScrollFunc {
    constructor() {
        this.lenis = null;
        this.baseDeviceWidth = getComputedStyle(document.documentElement).getPropertyValue("--baseDeviceWidth"); //cssから取得
        this.scrollTriggers = []; // ScrollTriggerを管理
        this.init();
    }

    init() {
        this.initLenis();
        this.onScroll();
        this.fadeOnScroll();
        this.toggleFloatingButton();
        this.fadeOutScroll();
        this.observeDomResize();

        let resizeTimer;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(() => {
                this.handleResize();
            }, 200);
        });
    }

    handleResize() {
        // 既存のScrollTriggerを削除
        this.scrollTriggers.forEach((st) => st.kill());
        this.scrollTriggers = [];

        // 未表示の要素のみScrollTriggerを再作成
        this.onScroll();
        ScrollTrigger.refresh();
    }

    initLenis() {
        this.lenis = new Lenis({
            smooth: true,
            smoothTouch: true,
        });

        //gsapのtickerと同期
        gsap.ticker.add((time) => {
            this.lenis.raf(time * 1000);
        });

        //Lenis使用の際は、gsapのlagSmoothingを無効化
        gsap.ticker.lagSmoothing(0);

        //LenisでスクロールするたびにScrollTriggerを更新
        this.lenis.on("scroll", ScrollTrigger.update);
    }

    refresh() {
        ScrollTrigger.refresh();
    }

    observeDomResize() {
        if (typeof ResizeObserver === "undefined") return;

        let resizeTimer;
        const observer = new ResizeObserver(() => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                ScrollTrigger.refresh();
            }, 100);
        });

        observer.observe(document.body);
    }

    onScroll() {
        const revealElm = [...document.querySelectorAll(".js-scrollreveal")];

        revealElm.forEach((el) => {
            // 既に表示済み(-completedクラスがある)の要素はスキップ
            if (el.classList.contains("-completed")) return;

            const startPos = el.dataset.start || "top 60%";
            const st = ScrollTrigger.create({
                trigger: el,
                start: startPos,
                onEnter: () => {
                    el.classList.add("-reveal");
                    setTimeout(() => {
                        el.classList.add("-completed");
                    }, 1000);
                },
            });
            this.scrollTriggers.push(st);
        });
    }

    fadeOnScroll() {
        const fadeElm = [...document.querySelectorAll(".js-scroll-fade")];
        const newsSection = document.querySelector(".js-news");
        fadeElm.forEach((el) => {
            const startPos = el.dataset.start || "top top";

            gsap.fromTo(
                el,
                { opacity: 1 },
                {
                    opacity: 0,
                    scrollTrigger: {
                        trigger: newsSection,
                        start: startPos,
                        end: "+=20",
                        scrub: true,
                    },
                }
            );
        });
    }

    toggleFloatingButton() {
        const floatingBtn = document.querySelector(".js-floatingbtn");
        const newsSection = document.querySelector(".js-news");

        if (!floatingBtn || !newsSection) {
            return;
        }

        ScrollTrigger.create({
            trigger: newsSection,
            start: "bottom bottom",
            onEnter: () => {
                floatingBtn.classList.add("-show");
            },
            onLeaveBack: () => {
                floatingBtn.classList.remove("-show");
            },
        });
    }

    fadeOutScroll() {
        const fadeElm = [...document.querySelectorAll(".js-scroll-fade-out")];
        const footerSection = document.querySelector(".l-footer");
        fadeElm.forEach((el) => {
            gsap.fromTo(
                el,
                { autoAlpha: 1 },
                {
                    autoAlpha: 0,
                    scrollTrigger: {
                        trigger: footerSection,
                        start: "0% 100%",
                        end: "50% 100%",
                        scrub: true,
                    },
                }
            );
        });
    }
}
